module.exports = __webpack_public_path__ + "static/media/16.Sieve-Set-for-Fine-Aggregate.b8859908.webp";